<template>
  <md-card>
    <md-card-header>
      <div class="md-layout">
        <div class="md-layout-item md-size-90">
          <h4 class="title">Bookings</h4>
        </div>
        <div class="md-layout-item md-size-10 text-right">
          <md-button
            class="md-icon-button md-dense md-primary md-round"
            @click.prevent="bookingDialog = true"
          >
            <md-icon>add</md-icon>
            <md-tooltip md-direction="top"
              >Create a new Booking<br />for
              {{ this.customer.full_name }}</md-tooltip
            >
          </md-button>
        </div>
      </div>
    </md-card-header>
    <md-card-content>
      <div class="md-layout-item md-small-size-100 md-size-100">
        <time-line
          plain
          type="simple"
          id="booking_timeline"
          v-if="bookings.length"
        >
          <time-line-item
            inverted
            badge-type="primary"
            badge-icon="event_available"
            v-for="booking in bookings"
            :key="booking.id"
          >
            <div class="md-layout" slot="header">
              <div class="md-layout-item md-size-60">
                <i class="fas fa-clock text-primary"></i>
                {{ booking.booking_date | formatDate }}
              </div>
              <div
                class="md-layout-item md-size-40 text-right"
                style="align-items:flex-start"
              >
                <span class="badge badge-success"
                  >Booking ID: <strong>{{ booking.id }}</strong></span
                >
              </div>
            </div>
            <div class="md-layout md-alignment-bottom-left" slot="content">
              <div class="md-layout-item md-size-60 booking-summary">
                <ul>
                  <li>
                    <span>ROLE : </span
                    ><span>{{ bookerStatus(booking.lead_booker_id) }}</span>
                  </li>
                  <li>
                    <span>ADVENTURE : </span
                    ><router-link
                      v-if="booking.departure.tour"
                      :to="{
                        name: 'Adventure Profile',
                        params: { tour_id: booking.departure.tour.id }
                      }"
                    >
                      {{ booking.departure.tour.title }}</router-link
                    >
                    <span v-else>UNKNOWN</span>
                  </li>
                  <li>
                    <span>DEPARTURE : </span
                    ><router-link
                      v-if="booking.departure.tour"
                      :to="{
                        name: 'Departure Profile',
                        params: {
                          tour_id: booking.departure.tour.id,
                          departure_id: booking.departure.id
                        }
                      }"
                      >{{
                        booking.departure.start_date | formatDate
                      }}</router-link
                    ><span v-else>{{
                      booking.departure.start_date | formatDate
                    }}</span>
                  </li>
                  <li>
                    <span>STATUS : </span
                    ><span :class="statusClass(booking.status.key)">{{
                      booking.status.description
                    }}</span>
                  </li>
                </ul>
              </div>
              <div class="md-layout-item md-size-40 text-right ">
                <md-button
                  :to="{
                    name: 'Booking Profile',
                    params: { id: booking.id }
                  }"
                  class="md-primary md-dense"
                >
                  <md-icon>visibility</md-icon> view...
                  <md-tooltip md-direction="top">View</md-tooltip>
                </md-button>
              </div>
            </div>
          </time-line-item>
        </time-line>

        <md-empty-state
          v-else
          md-label="Book 'em Danno"
          md-description="Let's get this Customer booked on a trip."
        >
          <md-button
            class="md-primary md-raised"
            @click.prevent="bookingDialog = true"
            >Create a booking</md-button
          >
        </md-empty-state>

        <booking-create-dialog
          :bookingDialog="bookingDialog"
          :customer="customer"
          @booking-created="bookingCreated"
          @cancel="bookingDialog = false"
        />
      </div>
    </md-card-content>
  </md-card>
</template>

<script>
import customerApi from "@/services/api/customer";
import { TimeLine, TimeLineItem } from "@/components";

import BookingCreateDialog from "./BookingCreateDialog.vue";

export default {
  props: ["customer"],

  data() {
    return {
      bookings: [],
      bookingDialog: false
    };
  },

  components: {
    TimeLine,
    TimeLineItem,
    BookingCreateDialog
  },

  methods: {
    getBookings() {
      customerApi.getBookings(this.customer).then(resp => {
        this.bookings = resp.data;
      });
    },

    bookingCreated(booking) {
      this.bookingDialog = false;

      this.$router.push({
        name: "Booking Profile",
        params: { id: booking.id }
      });
    },

    statusClass(key) {
      if (["Cancelled", "CancelledCredit"].includes(key)) {
        return "text-danger";
      }

      if (key == "Abandoned") {
        return "text-abandoned";
      }

      return "text-success";
    },

    bookerStatus(userId) {
      return userId == this.customer.id ? "Lead Booker" : "Traveller";
    }
  },

  mounted() {
    this.getBookings();
  }
};
</script>

<style lang="scss">
#booking_timeline {
  margin-top: 0px;
}
#booking_timeline .timeline.timeline-simple {
  margin-top: 0;
  padding-top: 0;
}
</style>
<style lang="scss" scoped>
@import "@/assets/scss/md/_variables.scss";

h6 {
  margin-bottom: 1rem;
}

.text-abandoned {
  color: $blue-grey-500;
}
</style>
